import { defineCustomElement } from 'vue'
import ProblemiTecniciWiperWC from './ProblemiTecniciWiperWC.ce.vue'

const ProblemiTecniciWiperWCElement = defineCustomElement(ProblemiTecniciWiperWC)


customElements.define('pt-wiper', ProblemiTecniciWiperWCElement)
